/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext, lazy, Suspense } from "react";
// import "./AppHeader.css";
import { injectIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { ICommandBarItemProps } from "@fluentui/react/lib/CommandBar";
import { CoherenceHeader } from "@coherence-design-system/controls";
import { ServiceContext, ApplicationContext } from "@msx/platform-services";
import { V2_HeaderProps } from "./V2_AppHeader.types";
import { messages } from ".././AppHeader.messages";
import { Stack, Panel, PanelType, IconButton, Icon, Button } from "@fluentui/react";
import { makeStyles } from "@fluentui/react-components";
import { ArrowClockwiseRegular } from "@fluentui/react-icons";
import { useBoolean } from "@fluentui/react-hooks";
import { IAppConfig } from "../../../App.config";
import { getNotifications } from "../../../../app/store";
import { withRouter } from "react-router-dom";
import fakebotdata from "../../../../app/components/header/fakeBot.json";
import {
  getBotToken,
  getTitleLoaderName,
  getisBotError,
  getisLoader,
  setIsBotError,
  setIsLoader,
  settitleLoaderName,
} from "../../../../core/store";
import { useMCAPSCopilotTelemetry } from "../../copilot/utils/mcapsCopilotTelemetry";
import { lazyRetry } from "../../../utils/utils";
import { V2_EditProfile } from "../../editprofile/V2component_Editprofile/V2_EditProfile";
import { MCAPSCopilotPanelWrapper } from "../../copilot";
import { isFeatureEnabled } from "../../../services/FeatureFlagService";
import {
  DEFAULT_MCAPS_COPILOT_FEATURE_FLAG,
  GENERIC_MCAPS_COPILOT_APP_NAME,
  MCAPSCopilotContext,
} from "../../copilot/defaultAgent";
// import { lazyRetry } from "../../utils/utils";

// Event source constants for agent routing
const EVENT_SOURCE_DATABASE = 'database-config';
const EVENT_SOURCE_ECIF = 'ECIF';

const useStyles = makeStyles({
  headerBtton: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: "0px",
    minWidth: "auto",
    height: "auto",
    margin: "0px"
  }

});
const EditProfile = lazy(() =>
  lazyRetry(() =>
    import("../../editprofile/EditProfile").then((module) => ({
      default: module.EditProfile,
    }))
  )
);
const Settings = lazy(() =>
  lazyRetry(() =>
    import("../..").then((module) => ({ default: module.Settings }))
  )
);
const FeedbackPanel = lazy(() =>
  lazyRetry(() => import("../../feedback/FeedbackPanel"))
);
const AboutHelp = lazy(() =>
  lazyRetry(() =>
    import("../../help/AboutHelp").then((module) => ({
      default: module.AboutHelp,
    }))
  )
);

const V2_AppHeaderComponent: React.FC<V2_HeaderProps> = (props) => {
  const styles = useStyles();
  let irisBotchat = false;
  const getToken = useSelector(getBotToken);
  const loaderName = useSelector(getTitleLoaderName);
  const isBotLoader = useSelector(getisLoader);
  const isBotError = useSelector(getisBotError);
  const reduxDispatch = useDispatch();
  const { appState } = useContext(ApplicationContext);
  const context = React.useContext(ServiceContext);
  const notifications = useSelector(getNotifications);
  const [dismissOpenedPanel, setDismissOpenedPanel] = useState(false);
  const [dismissPanelButtonClick, setDismissPanelButtonClick] = useState(false);
  const [dismissHelpOpenedPanel, setDismissHelpOpenedPanel] = useState(false);
  const [dismissHelpPanelButtonClick, setDismissHelpPanelButtonClick] =
    useState(false);
  const { intl, isUserLoggedIn, appName, isAppReady, isEditableProfile } =
    props;
  const [
    isNotificationsOpen,
    { setTrue: openNotificationsPanel, setFalse: dismissNotificationsPanel },
  ] = useBoolean(false);
  const appConfig = appState?.appConfig as IAppConfig;

  // MCAPS Copilot Integration
  const mcapsTelemetry = useMCAPSCopilotTelemetry(reduxDispatch);
  const [isCopilotPanelOpen, setIsCopilotPanelOpen] = useState(false);
  const [copilotContext, setCopilotContext] =
    useState<MCAPSCopilotContext>('generic');
  const [initialCopilotPrompt, setInitialCopilotPrompt] = useState<string | undefined>(undefined);
  // Tracks whether the user has explicitly dismissed the default MCAPS Copilot on
  // an allowed tab, so the convergent auto-open effect below does not immediately
  // reopen it. Re-armed (reset to false) whenever the copilot cannot be shown
  // (e.g. the user leaves the allowed tabs), matching the prior "respected only
  // while on an allowed tab" semantics.
  const userDismissedDefaultCopilotRef = React.useRef(false);
  // Mirrors the latest `selectedActiveTab` so the (mount-scoped) access-resolved
  // listener below can evaluate the allowed-tab guard against the current tab
  // without a stale closure.
  const selectedActiveTabRef = React.useRef(props.selectedActiveTab);
  selectedActiveTabRef.current = props.selectedActiveTab;
  // Tracks whether copilot access has been resolved (via the 'copilotAccessMapReady'
  // event / a prior visit), regardless of whether it was granted or denied. Seeds
  // true on a reload where sessionStorage already holds the outcome, and false on a
  // genuine cold visit where access is still pending. Used to suppress the legacy
  // IRIS loader flash while the default MCAPS Copilot is about to take over.
  const [isCopilotAccessResolved, setIsCopilotAccessResolved] = useState(
    () => sessionStorage.getItem('hasCopilotAccess') !== null
  );
  const isDefaultMcapsCopilotEnabled = isFeatureEnabled(
    DEFAULT_MCAPS_COPILOT_FEATURE_FLAG
  );
  // Tabs are keyed as: "0" = My Help Workspace, "1" = Catalog,
  // "2" = My Tickets, "3" = My Voice/Feedback. Restrict MCAPS
  // Copilot to My Help Workspace and My Tickets only.
  const allowedCopilotTabs = ["0", "2"]; // itemKey values
  const isCopilotAllowedForTab = allowedCopilotTabs.includes(props.selectedActiveTab);
  const canShowMcapsCopilot = !!props.isMCAPSCopilotEnabled && isCopilotAllowedForTab;

  // A parameterized tile deep link (?tilename=...) routes IRIS itself, so the
  // generic homepage default-MCAPS behaviour stands down and the IRIS loader must
  // stay visible.
  const isTileDeepLinkPresent = React.useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return Array.from(urlParams.keys()).some(
      (key) => key.toLowerCase() === 'tilename'
    );
  }, []);

  // On a cold visit, while the default MCAPS Copilot is enabled and about to open
  // on an allowed homepage tab, suppress the legacy IRIS loader until access
  // resolves. This avoids the brief "IRIS Copilot" loader flash before MCAPS takes
  // over. If access resolves to "no access", the flag falls through and the IRIS
  // loader shows normally.
  const suppressIrisLoaderForPendingMcaps =
    isDefaultMcapsCopilotEnabled &&
    isCopilotAllowedForTab &&
    !isTileDeepLinkPresent &&
    !isCopilotAccessResolved;

  const updateCopilotAppName = (
    nextAppName: string | undefined,
    source: string
  ) => {
    const previousAppName =
      sessionStorage.getItem('mcapsCopilot_appName') || '';

    if (nextAppName) {
      sessionStorage.setItem('mcapsCopilot_appName', nextAppName);
    } else {
      sessionStorage.removeItem('mcapsCopilot_appName');
    }

    const currentAppName =
      sessionStorage.getItem('mcapsCopilot_appName') || '';
    if (previousAppName !== currentAppName) {
      window.dispatchEvent(new CustomEvent('mcapsCopilot_triggerReset', {
        detail: { timestamp: Date.now(), source }
      }));
      sessionStorage.setItem(
        'mcapsCopilot_triggerFullClear',
        Date.now().toString()
      );
      setTimeout(
        () => window.dispatchEvent(
          new CustomEvent('mcapsCopilot_appNameChanged')
        ),
        0
      );
    }
  };

  useEffect(() => {
    try {
      sessionStorage.removeItem('copilotOpenState');
      sessionStorage.removeItem('MCAPS_COPILOT_CONVERSATION_ID');
    } catch {}
  }, []);

  // Simple MCAPS Copilot Panel Handler
  const openMCAPSCopilot = (bypassPermissionCheck = false) => {

    if (!canShowMcapsCopilot && !bypassPermissionCheck) {
      return;
    }

    try {
      props.hideIrisBot?.();
      // Close all other panels first
      closeAllPanels('mcaps-copilot');

      // Telemetry: MCAPS Copilot Panel Opened
      mcapsTelemetry.logPanelOpened();

      // Handle focus management for MCAPS copilot
      const buttons = document.querySelectorAll(".ms-CommandBarItem-link");
      buttons.forEach(button => button.classList.remove("is-checked"));

      // Find the MCAPS button and add is-checked class
      const mcapsButton = document.getElementById("mcapshelp-copilot");
      if (mcapsButton) {
        mcapsButton.classList.add("is-checked");
      }

      // Clear Iris icon state
      handleIrisIcon("Iris", false);

      const id = crypto.randomUUID();
      sessionStorage.setItem('MCAPS_COPILOT_CONVERSATION_ID', id);
      try { sessionStorage.setItem('copilotOpenState', 'true'); } catch(e) {}

      setIsCopilotPanelOpen(true);

    } catch (error) {
      console.error("Error in openMCAPSCopilot:", error);
    }
  };

  const openGenericMCAPSCopilot = () => {
    if (!canShowMcapsCopilot) {
      return;
    }

    setCopilotContext('generic');
    setInitialCopilotPrompt(undefined);
    updateCopilotAppName(
      GENERIC_MCAPS_COPILOT_APP_NAME,
      'genericContext'
    );
    openMCAPSCopilot(false);
  };

  // Cold-load default open, driven directly by the 'copilotAccessMapReady' event.
  //
  // On a genuine first visit, copilot access resolves out-of-band and flips
  // `props.isMCAPSCopilotEnabled` (and thus the derived `canShowMcapsCopilot`) only
  // on the NEXT render — a render behind this event. The convergent effect below
  // reconciles the steady state on that flip for the warm/reload path (where
  // `canShowMcapsCopilot` is already true at mount), but on cold load the event
  // fires while the derived prop still reads false, so we open here imperatively.
  //
  // This reads only fresh sources (sessionStorage + a live feature-flag lookup +
  // refs) so it stays correct even though the access listener is registered once
  // (mount-scoped closure), and it opens MCAPS with a permission bypass because the
  // canonical access signal is `hasCopilotAccess` in sessionStorage, not the
  // lagging prop. All the default-agent gating still applies.
  const openDefaultMcapsOnAccessResolved = () => {
    if (!isFeatureEnabled(DEFAULT_MCAPS_COPILOT_FEATURE_FLAG)) {
      return;
    }
    if (sessionStorage.getItem('hasCopilotAccess') !== 'true') {
      return;
    }
    if (!allowedCopilotTabs.includes(selectedActiveTabRef.current)) {
      return;
    }
    if (
      sessionStorage.getItem('copilotOpenState') === 'true' ||
      userDismissedDefaultCopilotRef.current
    ) {
      return;
    }
    if (
      isTileDeepLinkPresent ||
      sessionStorage.getItem('mcapsCopilot_deeplinkPrompt')
    ) {
      return;
    }

    setCopilotContext('generic');
    setInitialCopilotPrompt(undefined);
    updateCopilotAppName(GENERIC_MCAPS_COPILOT_APP_NAME, 'genericContext');
    openMCAPSCopilot(true);
  };

  const closeMCAPSCopilot = ({ initializeIris = false }: { initializeIris?: boolean } = {}) => {
    setIsCopilotPanelOpen(false);
    try {
      sessionStorage.setItem('copilotOpenState', 'false');
      // Clear ECIF context when closing copilot to prevent context leakage
      sessionStorage.removeItem('mcapsCopilot_appName');
    } catch { }

    // Clear any stale IRIS loader text/state left by MCAPS-routed starts.
    reduxDispatch(settitleLoaderName(""));
    reduxDispatch(setIsLoader(false));
    reduxDispatch(setIsBotError(false));

    // Manual close should re-initialize IRIS the same way as clicking the IRIS button.
    if (initializeIris) {
      props.handleChatBotIconClick?.();
    }
  };

  const exitTileContext = () => {
    if (!isDefaultMcapsCopilotEnabled) {
      closeMCAPSCopilot({ initializeIris: true });
      return;
    }

    openGenericMCAPSCopilot();
  };

  // Convergent (self-healing) default MCAPS auto-open.
  //
  // This reconciles to the desired steady state instead of latching once. Whenever
  // the default agent is enabled, MCAPS Copilot can be shown on the current tab
  // (access resolved + allowed tab), the panel is closed, the user has not
  // dismissed it, and no tile deep link owns the open, open the generic homepage
  // MCAPS Copilot. Keying on the actual `isCopilotPanelOpen` state (rather than a
  // one-shot ref) makes cold load deterministic: on a genuine first visit, copilot
  // access resolves late and flips isMCAPSCopilotEnabled -> canShowMcapsCopilot
  // true out-of-band (via the 'copilotAccessMapReady' event handled in V2_Shell);
  // this effect re-runs on that transition and opens. There is no latch that a
  // transient/failed open during the unsettled cold-load window can "consume" and
  // then permanently block the real open with (the previous cold-load bug where
  // IRIS stayed open until a hard refresh).
  useEffect(() => {
    if (!isDefaultMcapsCopilotEnabled) {
      return;
    }

    // Re-arm the user-dismiss guard whenever MCAPS Copilot cannot be shown (e.g.
    // the user leaves the allowed tabs, or access is not yet / no longer granted),
    // so returning to an allowed tab opens the default agent again.
    if (!canShowMcapsCopilot) {
      userDismissedDefaultCopilotRef.current = false;
      return;
    }

    if (isCopilotPanelOpen || userDismissedDefaultCopilotRef.current) {
      return;
    }

    // On a parameterized tile deep link (?tilename=...), the targeted tile's own
    // routing decides which agent opens (IRIS via ServiceRouter, or MCAPS Copilot
    // via the 'open-mcaps-copilot' event), so the generic homepage auto-open stands
    // down. A pending MCAPS deep-link prompt is likewise handled by its own path.
    if (
      isTileDeepLinkPresent ||
      sessionStorage.getItem('mcapsCopilot_deeplinkPrompt')
    ) {
      return;
    }

    openGenericMCAPSCopilot();
  }, [canShowMcapsCopilot, isDefaultMcapsCopilotEnabled, isCopilotPanelOpen]);

  // Track copilot access resolution for the IRIS-loader flash suppression below.
  // The convergent auto-open effect above performs the actual open once
  // `canShowMcapsCopilot` becomes true; here we only record that the access
  // outcome is known so the legacy IRIS loader can be suppressed while the default
  // MCAPS Copilot takes over on a cold visit.
  // Track copilot access resolution for the IRIS-loader flash suppression below,
  // and drive the cold-load default open. The convergent auto-open effect above
  // reconciles the warm/reload path (where `canShowMcapsCopilot` is already true at
  // mount); on a genuine cold visit the access outcome arrives via this event a
  // render before the derived prop flips, so we also open here imperatively.
  useEffect(() => {
    const handleAccessResolved = () => {
      setIsCopilotAccessResolved(true);
      openDefaultMcapsOnAccessResolved();
    };
    window.addEventListener('copilotAccessMapReady', handleAccessResolved);
    // Reconcile the race where access already resolved before this listener
    // attached (the event fired during the render/commit gap). Only act when the
    // outcome is actually known, so a genuine cold visit stays "pending".
    if (sessionStorage.getItem('hasCopilotAccess') !== null) {
      setIsCopilotAccessResolved(true);
      openDefaultMcapsOnAccessResolved();
    }
    return () =>
      window.removeEventListener('copilotAccessMapReady', handleAccessResolved);
  }, []);

  // Ensure MCAPS Copilot is not visible on tabs other than
  // "My Help Workspace" and "My Tickets". When user navigates
  // away from allowed tabs, automatically close the panel.
  useEffect(() => {
    if (!isCopilotAllowedForTab && isCopilotPanelOpen) {
      closeMCAPSCopilot({ initializeIris: false });
    }
  }, [isCopilotAllowedForTab, isCopilotPanelOpen]);

  // On initial mount, check if a deep-link prompt was stored and, if so,
  // open MCAPS Copilot with that prompt pre-populated in the input box.
  useEffect(() => {
  try {
    const storedPrompt = sessionStorage.getItem('mcapsCopilot_deeplinkPrompt');
    const storedContext = sessionStorage.getItem('mcapsCopilot_deeplinkContext');
    if (storedPrompt) {
      setInitialCopilotPrompt(storedPrompt);
      sessionStorage.removeItem('mcapsCopilot_deeplinkPrompt');
      // If there's stored context with app info, preserve it for the copilot panel
      if (storedContext) {
        try {
          const context = JSON.parse(storedContext);
          if (context.appName) {
            sessionStorage.setItem('mcapsCopilot_appName', context.appName);
            setCopilotContext('tile');
          }
          sessionStorage.removeItem('mcapsCopilot_deeplinkContext');
        } catch {
          // Ignore JSON parsing errors
        }
      }
 
      if (canShowMcapsCopilot) {
        openMCAPSCopilot(false);
      }
    }
  } catch {
    // Ignore storage errors and proceed without deep-link behavior
  }
}, [canShowMcapsCopilot]);

  // Allow other components (e.g. tiles) to open MCAPS Copilot via a global event
  useEffect(() => {
    const handleGlobalOpenCopilot = (event) => {
      // Check if this is from database-configured tile (IrisAppName starts with 'MCAPSHelpCopilot')
      const isDatabaseConfigured = event.detail && event.detail.source === EVENT_SOURCE_DATABASE;
      // For ECIF tiles, we need to be more permissive since they should always work
      const isECIFEvent = event.detail && event.detail.source === EVENT_SOURCE_ECIF;
      const eventInitialPrompt = event.detail && event.detail.initialPrompt;

      // Allow database-configured tiles OR ECIF tiles to bypass permission check
      if (!canShowMcapsCopilot && !isECIFEvent && !isDatabaseConfigured) {
        return;
      }
      if (eventInitialPrompt) {
        setInitialCopilotPrompt(eventInitialPrompt);
      }
      
      setCopilotContext('tile');
      props.hideIrisBot?.();

      // Use appName from event detail (from DB AppName column via V2_Tile)
      const appName = event.detail?.appName;
      updateCopilotAppName(appName, 'tileClick');
      // Pass bypass flag if it's an ECIF event or database-configured
      openMCAPSCopilot(isECIFEvent || isDatabaseConfigured);
    };


    window.addEventListener('open-mcaps-copilot', handleGlobalOpenCopilot);

    // Test that the listener is properly attached
    setTimeout(() => {

      const testEvent = new CustomEvent('open-mcaps-copilot', { detail: { test: 'from V2_AppHeader setup' } });

    }, 1000);

    return () => {

      window.removeEventListener('open-mcaps-copilot', handleGlobalOpenCopilot);
    };
  }, [canShowMcapsCopilot]); // Re-attach listener when permission changes

  // Function to close all panels to ensure only one is active at a time
  const closeAllPanels = (excludePanel?: string) => {
    // Close MCAPS Copilot panel. When the default MCAPS Copilot agent is
    // enabled it behaves like the legacy IRIS dock (which was never part of
    // this exclusive panel set), so opening feedback/notifications/help/
    // profile/chatbot must NOT close it — it stays open behind those panels.
    if (excludePanel !== 'mcaps-copilot' && !isDefaultMcapsCopilotEnabled) {
      setIsCopilotPanelOpen(false);
      try { sessionStorage.setItem('copilotOpenState', 'false'); } catch {}
    }

    // Close Profile panel
    if (excludePanel !== 'profile') {
      setDismissOpenedPanel(false);
    }

    // Close Help panel  
    if (excludePanel !== 'help') {
      setDismissHelpOpenedPanel(false);
    }

    // Close Notifications panel
    if (excludePanel !== 'notifications') {
      dismissNotificationsPanel();
    }

    // Close Feedback panel
    if (excludePanel !== 'feedback') {
      setIsFeedbackPanelOpen(false);
    }

    // Close MCAPS Chat Bot
    if (excludePanel !== 'chatbot') {
      setIsMCAPSChatBotStarted(false);
    }
  };

  const [isMCAPSChatBotStarted, setIsMCAPSChatBotStarted] = useState(false);
  const [isFeedbackPanelOpen, setIsFeedbackPanelOpen] = useState(false);
  const [fakebot, setFakebot] = useState<any>({});
  const wcRef = React.useRef<any>(null);
  let intervalId: NodeJS.Timeout;
  const sastoken = sessionStorage.getItem("SasTokenKey") || "";
  const [isOpen, setIsOpen] = useState(false);
  const [images, setImages] = useState({
    copilot: process.env.REACT_APP_BLOBSASSTART + "BotIconthin.svg" + sastoken,
    copilotselected:
      process.env.REACT_APP_BLOBSASSTART + "BotIconthinblue.svg" + sastoken,
    fail: null,
    Magicimage: null,
    CoffeeLoader: null,
  });
  useEffect(() => {
    dismissPanelButtonClick && setDismissOpenedPanel(false);
  }, [dismissPanelButtonClick]);


  useEffect(() => {
    if (dismissOpenedPanel) {
      let intervalId = setInterval(() => {
        const closeButton = document.querySelector(".ms-Panel-closeButton");
        if (closeButton) {
          closeButton.setAttribute("aria-label", "Close");
          clearInterval(intervalId);
        }
      }, 1000);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId); // Clear interval on component unmount
      }
    }; // Add return statement
  }, [dismissOpenedPanel]);

  useEffect(() => {
    dismissHelpPanelButtonClick && setDismissHelpOpenedPanel(false);
  }, [dismissHelpPanelButtonClick]);

  // Accessibility fix: Make skip to main content link functional
  useEffect(() => {
    const fixSkipLink = () => {
      const skipLinks = document.querySelectorAll('a.ms-Link[tabindex="0"]');
      skipLinks.forEach((link) => {
        if (link.textContent?.includes('Skip to main content')) {
          // Set href to navigate to main content
          link.setAttribute('href', '#main');
          // Add click handler
          link.addEventListener('click', (e) => {
            e.preventDefault();
            const mainElement = document.getElementById('main');
            if (mainElement) {
              mainElement.focus();
              mainElement.scrollIntoView({ behavior: 'smooth' });
            }
          });
          // Add keydown handler for Enter key
          link.addEventListener('keydown', (e: Event) => {
            const keyboardEvent = e as KeyboardEvent;
            if (keyboardEvent.key === 'Enter') {
              e.preventDefault();
              const mainElement = document.getElementById('main');
              if (mainElement) {
                mainElement.focus();
                mainElement.scrollIntoView({ behavior: 'smooth' });
              }
            }
          });
        }
      });
    };

    // Run after component mounts
    const timeoutId = setTimeout(fixSkipLink, 500);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const fetchJsonData = async () => {
      try {
        const jsonData = `${process.env.REACT_APP_BLOBSASSTART + "JSON/fakeBot.json" + sastoken
          }`;
        const response = await fetch(jsonData);
        const data = await response.json();
        setFakebot(data);
      } catch (error) {
        const data = fakebotdata;
        setFakebot(data);
      }
    };
    fetchJsonData();
  }, []);

  useEffect(() => {
    checkAndAddClass();
    attachButtonClick();
    // Removed obserMovments() - handled below
  }, []);

  useEffect(() => {
    reduxDispatch(setIsBotError(false));
    if (props.selectedActiveTab === "0") {
      checkIrisMenu();
    } else {
      reduxDispatch(setIsLoader(false));
    }
  }, [props.selectedActiveTab]);

  useEffect(() => {
    if (sastoken) {
      setImages({
        copilot: `${process.env.REACT_APP_BLOBSASSTART + "BotIconthin.svg" + sastoken
          }`,
        copilotselected: `${process.env.REACT_APP_BLOBSASSTART + "BotIconthinblue.svg" + sastoken
          }`,
        fail: `${process.env.REACT_APP_BLOBSASSTART + "fail.png" + sastoken}`,
        Magicimage: `${process.env.REACT_APP_BLOBSASSTART + "Magicimage.gif" + sastoken
          }`,
        CoffeeLoader: `${process.env.REACT_APP_BLOBSASSTART + "CoffeeLoader.gif" + sastoken
          }`,
      });
    }
  }, [sastoken]);

  useEffect(() => {
    // Single interval to check and add class only when needed
    const intervalId = setInterval(() => {
      // Only check if MCAPS panel is NOT open
      if (!isCopilotPanelOpen) {
        // Inline the check here to avoid scope issues
        let elementsWithClass = document.querySelectorAll(".is-checked");
        let lengthOfIsCheckedClass = elementsWithClass.length;

        if (lengthOfIsCheckedClass === 0) {
          const irisButton = document.getElementById("Iris");
          if (irisButton && !irisButton.classList.contains("is-checked")) {
            handleIrisIcon("Iris", true);
            setIsChecked("header-chat-bot", true);
          }
        }
      }
    }, 1000); // Reduced frequency from 500ms to 1000ms

    // Cleanup on unmount
    return () => {
      clearInterval(intervalId);
    };
  }, [isCopilotPanelOpen, images]); // Re-run when copilot panel state or images change

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        const panel = document.querySelector("#headerTab").parentNode.parentNode
          .parentNode as HTMLElement;
        panel.style.zIndex = "20000000";
      }, 100);
    }
  }, [isOpen]);

  useEffect(() => {
    if (getToken !== "null") {
      handleTabKey();
    }
  }, [getToken, isBotLoader]);

  useEffect(() => {
    if (props.selectedActiveTab === "0" && isOpen) {
      setTimeout(() => {
        const panel = document.querySelector("#headerTab");

        if (panel !== null) {
          let ele = panel.parentNode.parentNode.parentNode as HTMLElement;
          ele.style.zIndex = "200000000";
        } else {
          const iris = document.querySelector("#irisMenu");

          if (iris !== null) {
            let ele = iris.parentNode.parentNode.parentNode.parentNode
              .parentNode.parentNode.parentNode.parentNode.parentNode
              .parentNode as HTMLElement;
            ele.style.zIndex = "-1";
          }
        }
      }, 3000);
    }
  }, [props.selectedActiveTab, isOpen === true]);

  useEffect(() => {
    processNotificaitons();
    // eslint-disable-next-line
  }, [notifications]);





  const checkIrisMenu = () => {
    if (!irisBotchat) {
      const irisMenu = document.querySelector(".ms-layer");
      if (irisMenu?.innerHTML !== "") {
        setTimeout(() => {
          reduxDispatch(setIsLoader(false));
          irisBotchat = true;
        }, 9000);
      } else {
        reduxDispatch(setIsLoader(true));
        // If irisMenu is not found, retry after 500ms (increased from 40ms)
        setTimeout(checkIrisMenu, 500);
      }
    }
  };

  const obserMovments = () => {
    const itemIris = document.getElementById("Iris");

    if (itemIris !== null) {
      // Remove the duplicate setInterval - already handled in useEffect above
      // setInterval(checkAndAddClass, 500);
    }
  };

  const processNotificaitons = () => {
    let count = 0;
    if (notifications && notifications.length > 0) {
      notifications.forEach((item) => {
        if (item.status === "unread") count++;
      });
    }
  };

  const handleSignOut = () => {
    context.authClient.logOut();
  };

  const getHelpBody = () => {
    return (
      <Suspense fallback={<></>}>
        <AboutHelp isAppReady={isAppReady} />
      </Suspense>
    );
  };

  const getEditProfileBody = (onDismissProfilePanel: any) => {
    return (
      <Suspense fallback={<></>}>
        <V2_EditProfile
          isEditableProfile={isEditableProfile}
          currentUserData={props.currentUserData}
          getUserIDByEmailId={props.getUserIDByEmailId}
          onDismissOpenedPanel={onDismissProfilePanel}
          handleChatBotIconClick={props.handleChatBotIconClick}
        />
      </Suspense>
    );
  };

  const handleDismissPanel = (event) => {
    event.stopPropagation();
    setDismissOpenedPanel(!dismissOpenedPanel);
    setDismissPanelButtonClick(true);
  };

  const handleOpenPanel = () => {
    // Close all other panels first
    closeAllPanels('profile');

    setIsOpen(true);
    setDismissHelpOpenedPanel(false);
    setDismissOpenedPanel(true);
    // setDismissHelpOpenedPanel(false)
    if (dismissPanelButtonClick) {
      setDismissPanelButtonClick(false);
    }
  };

  const handleOpenHelpPanel = () => {
    // Close all other panels first
    closeAllPanels('help');

    //Set about pannel z-index when click on help button
    setTimeout(() => {
      let profileInner = document.querySelector(
        "#aboutpannelid"
      ) as HTMLElement | null;
      if (profileInner) {
        let grandGrandParent = profileInner.closest(
          ".ms-Layer.ms-Layer"
        ) as HTMLElement;

        if (grandGrandParent) {
          grandGrandParent.style.zIndex = "11000000";
        }

        //make info pannel z-index low when click on profile
        let contentInner = document.querySelector(
          ".infoPanelHeader"
        ) as HTMLElement;

        if (contentInner) {
          let grandGrandParent = contentInner.closest(
            ".ms-Layer.ms-Layer"
          ) as HTMLElement;

          if (grandGrandParent) {
            grandGrandParent.style.zIndex = "10000000";
          }
        }
      }
    }, 500);
    setIsOpen(true);
    setDismissHelpOpenedPanel(true);
    if (dismissHelpPanelButtonClick) {
      setDismissHelpPanelButtonClick(false);
    }
  };

  const getSettingsBody = () => {
    return (
      <Suspense fallback={<></>}>
        <Settings onDismissPanel={handleDismissPanel} />
      </Suspense>
    );
  };

  const attachButtonClick = () => {
    const buttons = document.querySelectorAll(".ms-CommandBarItem-link");
    function handleClick(button) {
      handleButtonClick(button);
    }
    buttons.forEach((button) => {
      // Use a named function reference for add/remove
      const clickHandler = () => handleClick(button);
      button.addEventListener("click", clickHandler);
      // Store the handler on the element for cleanup
      button["__irisClickHandler__"] = clickHandler;
    });

    // Cleanup event listeners when the component unmounts
    return () => {
      buttons.forEach((button) => {
        // Use the same function reference for removeEventListener
        if (button["__irisClickHandler__"]) {
          button.removeEventListener("click", button["__irisClickHandler__"]);
          delete button["__irisClickHandler__"];
        }
      });
    };
  };

  function checkAndAddClass() {
    // If MCAPS panel is open, do NOT force Iris selection
    if (isCopilotPanelOpen) return;

    // Select all elements with class "is-checked"
    let elementsWithClass = document.querySelectorAll(".is-checked");

    // Check the length of the NodeList
    let lengthOfIsCheckedClass = elementsWithClass.length;

    // If the length is zero, add the class to the Iris button
    if (lengthOfIsCheckedClass === 0) {
      const irisButton = document.getElementById("Iris");
      if (irisButton && !irisButton.classList.contains("is-checked")) {
        handleIrisIcon("Iris", true);
        setIsChecked("header-chat-bot", true);
      }
    }
  }

  const handleButtonClick = (button) => {
    setTimeout(() => {
      //make profile pannel z-index high when click on profile
      let profileInner = document.querySelector(
        ".editPrfofileContainer"
      ) as HTMLElement;

      if (profileInner) {
        let grandGrandParent = profileInner.closest(
          ".ms-Layer.ms-Layer"
        ) as HTMLElement;

        if (grandGrandParent) {
          grandGrandParent.style.zIndex = "11000000";
        }

        //make info pannel z-index low when click on profile

        let contentInner = document.querySelector(
          ".infoPanelHeader"
        ) as HTMLElement;

        if (contentInner) {
          let grandGrandParent = contentInner.closest(
            ".ms-Layer.ms-Layer"
          ) as HTMLElement;

          if (grandGrandParent) {
            grandGrandParent.style.zIndex = "10000000";
          }
        }
      }
    }, 500); // Delay of mili seconds
    // Remove 'is-checked' class from the previously checked button
    let elementsWithClass = document.querySelectorAll(
      ".ms-CommandBarItem-link"
    );

    // Loop through the selected elements and remove the class
    elementsWithClass.forEach(function (element) {
      element.classList.remove("is-checked");
    });

    // Add 'is-checked' class to the clicked button
    button.classList.add("is-checked");

    // Call your function based on button.id

    if (button.id === "Iris") {
      handleIrisIcon("Iris", true);
      setIsChecked("Iris", true);
    } else {
      handleIrisIcon("Iris", false);
      setIsChecked("Iris", false);
    }

    checkAndAddClass();
  };

  const setIsChecked = (item, ischeked) => {
    let headericon = document.getElementById(item);
    if (headericon) {
      if (ischeked === true) {
        headericon.classList.add("is-checked");
      } else {
        headericon.classList.remove("is-checked");
      }
    }
  };

  const handleIrisIcon = (item, checked) => {
    if (item === "Iris") {
      let irisicons = document.getElementsByClassName("imgIris");
      if (irisicons.length > 0) {
        const newSrc = checked === true ? images.copilotselected : images.copilot;
        // Change the src attribute only if it's different (prevent unnecessary updates)
        for (let i = 0; i < irisicons.length; i++) {
          if (irisicons[i]["src"] !== newSrc) {
            irisicons[i]["src"] = newSrc;
          }
        }
      }
    }
  };

  const getFarItems = (): ICommandBarItemProps[] => {
    let items = [
      {
        key: "feedback",
        id: "header-feedback",
        text: intl.formatMessage(messages.feedback),
        ariaLabel: intl.formatMessage(messages.feedbackAriaLabel),
        iconOnly: true,
        iconProps: {
          iconName: "Emoji2",
          style: { color: "white" },
        },
        buttonStyles: {
          root: {
            tabIndex: 0,
          },
        },
        onClick: () => {
          // Close all other panels first
          closeAllPanels('feedback');
          setIsFeedbackPanelOpen(true);
        },
        styles: {
          root: {
            color: "black",
            backgroundColor: "white",
            fontSize: "14px",
            visibility: "visible",
            opacity: 1,
          },
        },
      },
      {
        key: "Iris",
        id: "Iris",
        text: isCopilotPanelOpen
          ? "MCAPSHelp Agent"
          : "Click here to reset IRIS Copilot",
        ariaLabel: isCopilotPanelOpen ? "MCAPSHelp Agent" : "IRIS Copilot",
        //text:"IRIS Copilot",
        onClick: () => {
          if (isDefaultMcapsCopilotEnabled && canShowMcapsCopilot) {
            openGenericMCAPSCopilot();
          } else {
            closeAllPanels();
            props.handleChatBotIconClick();
          }
        },
        onRenderIcon: () => (
          <img
            key={images.copilot}
            className="imgIris"
            src={images.copilot}
            alt="Iris Bot"
          />
        ),
        buttonStyles: {
          root: {
            tabIndex: 0,
          },
        },
        styles: {
          root: {
            color: "black",
            backgroundColor: "white",
            fontSize: "14px",
            visibility: "visible",
            opacity: 1,
          },
        },
      },
      {
        key: "chatBot",
        id: "header-chat-bot",
        text: intl.formatMessage(messages.chatBot),
        ariaLabel: intl.formatMessage(messages.financeSupportBotAriaLabel),
        onRenderIcon: () => (
          <img
            key={images.copilot}
            className="imgIris"
            src={images.copilot}
            alt="Copilot"
          />
        ),
        iconOnly: true,
        buttonStyles: {
          root: {
            tabIndex: 0,
          },
        },
        onClick: () => {
          // Close all other panels first
          closeAllPanels('chatbot');
          setIsMCAPSChatBotStarted(!isMCAPSChatBotStarted);
        },
        styles: {
          root: {
            color: "black",
            backgroundColor: "white",
            fontSize: "14px",
            visibility: "visible",
            opacity: 1,
          },
        },
      },
      {
        key: "gudedTour",
        id: "header-guided-tour",
        text: intl.formatMessage(messages.retakeTour),
        ariaLabel: intl.formatMessage(messages.retakeTourAriaLabel),
        iconOnly: true,
        iconProps: {
          iconName: "ReadingMode",
        },
        onClick: () => { },
      },
      {
        key: "customNotificaiton",
        id: "header-my-notifications",
        text: intl.formatMessage(messages.settingsNotificationsTitle),
        ariaLabel: intl.formatMessage(messages.settingsNotificationsTitle),
        iconOnly: true,
        iconProps: {
          iconName: "Ringer",
        },
        onClick: handleNotificationsClick,
      },
    ];
    if (!isAppReady || !isUserLoggedIn) {
      items = items.filter(function (obj) {
        return obj.key !== "chatBot" && obj.key !== "gudedTour";
      });
      items = items.filter(function (obj) {
        return obj.key !== "customNotificaiton";
      });
      return items;
    }
    if (
      !appConfig.notificaitonConfig.active ||
      !appConfig.notificaitonConfig.customPanel
    ) {
      items = items.filter(function (obj) {
        return obj.key !== "customNotificaiton";
      });
    }
    if (!appConfig.botConfig.active) {
      items = items.filter(function (obj) {
        return obj.key !== "chatBot";
      });
    }
    if (!appConfig.guidedTourConfig.active) {
      items = items.filter(function (obj) {
        return obj.key !== "gudedTour";
      });
    }
    if (props.selectedActiveTab === "1" || props.selectedActiveTab === "3") {
      items = items.filter((e) => {
        return e.key !== "Iris";
      });
    }
    return items;
  };

  const handleNotificationsClick = () => {
    // Close all other panels first
    closeAllPanels('notifications');
    openNotificationsPanel();
  };

  const handleChatBotIconClick = async () => {
    reduxDispatch(setIsBotError(false));
    if (props.selectedActiveTab === "0") {
      reduxDispatch(setIsLoader(true));
    } else {
      reduxDispatch(setIsLoader(false));
    }
    reduxDispatch(settitleLoaderName(""));
    if (getToken == null) {
      setTimeout(() => {
        reduxDispatch(setIsBotError(true));
      }, 4000);
    } else {
      reduxDispatch(setIsLoader(false));
      reduxDispatch(setIsBotError(false));
    }
  };

  const renderNotificationsPanel = () => {
    if (!appConfig.notificaitonConfig.active) return null;
    if (!appConfig.notificaitonConfig.customPanel) return null;

    const panelStyle = { root: { marginTop: "48px" } };
    return (
      <Panel
        isLightDismiss
        isOpen={isNotificationsOpen}
        type={PanelType.medium}
        onDismiss={dismissNotificationsPanel}
        closeButtonAriaLabel="Close"
        headerText={intl.formatMessage(messages.settingsNotificationsTitle)}
        styles={panelStyle}
      >
        {renderNotificationsPanelBody()}
      </Panel>
    );
  };

  const renderNotificationsPanelBody = (): JSX.Element => {
    return (
      <Stack horizontalAlign={"start"}>
        <Stack.Item>{"display notification items here"}</Stack.Item>
      </Stack>
    );
  };

  const renderMCAPSChatBot = (): JSX.Element => {
    return <></>;
  };

  // Your existing code...

  const renderFullHeader = (): JSX.Element => {
    let profile = `${process.env.REACT_APP_BLOBSASSTART + "profile_logo.jpg" + sastoken
      }`;
    return (
      <div className="appHeader-position">
        <CoherenceHeader
          headerLabel={"header"}
          appNameSettings={{
            label: appName,
            ariaLabel: appName,
            linkUrl: "/",
          }}
          farRightSettings={{
            additionalItems: getFarItems(),

            helpSettings: {
              panelSettings: {
                titleText: intl.formatMessage(messages.helpSettingsTitle),
                body: getHelpBody(),
                className: "aboutPanel",
                id: "headerTab",
                tabIndex: 0,
                isOpen: dismissHelpOpenedPanel,
                onClick: () => handleOpenHelpPanel(),
              },
            },

            profileSettings: {
              panelSettings: {
                fullName: props.user.name,
                emailAddress: props.user.email,
                imageUrl: profile,
                logOutLink: "#",
                onLogOut: () => handleSignOut(),
                onRenderFooter: () => {
                  return (
                    <a
                      href="https://privacy.microsoft.com/en-us/privacystatement"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      Privacy Notice
                    </a>
                  );
                },
                body: getEditProfileBody(handleDismissPanel),
                isOpen: dismissOpenedPanel,
                onClick: () => handleOpenPanel(),
                id: "headerTab",
                className: "ProfileTab",
              },
            },
          }}
          dismissOpenedPanel={dismissOpenedPanel || dismissHelpOpenedPanel}
          onDismissOpenedPanel={() => {
            setDismissPanelButtonClick(true);
            setDismissHelpPanelButtonClick(true);
          }}
        />
      </div>
    );
  };

  const renderInitialHeader = (): JSX.Element => {
    return (
      <CoherenceHeader
        headerLabel={"header"}
        appNameSettings={{
          label: appName,
          ariaLabel: appName,
          linkUrl: "/",
        }}
      />
    );
  };

  const renderNotLoggedInHeader = (): JSX.Element => {
    return (
      <CoherenceHeader
        headerLabel={"header"}
        appNameSettings={{
          label: appName,
          ariaLabel: appName,
          linkUrl: "/",
        }}
        farRightSettings={{
          additionalItems: getFarItems(),
          settingsSettings: {
            panelSettings: {
              titleText: intl.formatMessage(messages.settingsSettingsTitle),
              body: getSettingsBody(),
            },
          },
        }}
      />
    );
  };

  // Function to find the next focusable element outside the ms-panel
  function findNextFocusableElement(panel) {
    // Assuming 'panel' is the ms-panel DOM element
    const focusableElements = "button, [href], input, select, textarea";
    const modalFocusableElements = panel.querySelectorAll(focusableElements);
    const lastFocusableElement =
      modalFocusableElements[modalFocusableElements.length - 1];

    // Event listener for the last focusable element in the ms-panel
    lastFocusableElement?.addEventListener("keydown", function (e) {
      const isTabPressed = e.key === "Tab" || e.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) {
        // if shift key pressed for shift + tab combination
        return;
      } else {
        // if tab key is pressed
        e.preventDefault();
        // Find the first focusable element outside the ms-panel
        const outsideFocusableElements: any = Array.from(
          document.querySelectorAll(focusableElements)
        ).filter((el) => !panel.contains(el));
        if (outsideFocusableElements.length > 0) {
          // Set focus to the next focusable element outside the ms-panel
          const firstPivotLinkElement = outsideFocusableElements.find((el) =>
            el.classList.contains("ms-Link")
          );
          if (firstPivotLinkElement) {
            // Set focus to the first .ms-Pivot-link element outside the ms-panel
            firstPivotLinkElement.focus();
          }
        }
      }
    });
  }

  const handleTabKey = () => {
    // Clear any existing interval before setting a new one
    if (intervalId) {
      clearInterval(intervalId);
    }

    intervalId = setInterval(() => {
      const msPanel = document.querySelector(".ms-Panel"); // Replace with the correct selector for your ms-panel
      if (msPanel) {
        findNextFocusableElement(msPanel);
        clearInterval(intervalId);
        intervalId = null; // Reset the reference
      }
    }, 300);
  };

  const renderMain = (): JSX.Element => {
    if (!isAppReady) return renderInitialHeader();
    if (!isUserLoggedIn) return renderNotLoggedInHeader();

    let loaderElement;
    if (isBotError) {
      loaderElement = (
        <div className="loadertitle">
          <img
            src={images.fail}
            id="iris-title"
            className="botImg"
            alt="Iris title icon"
          />
          <div className="loaderbody">
            <div className="errorBody">Agent temporarily unavailable. Please try again.</div>
          </div>
          <button
            type="submit"
            className="refeshbtn"
            onClick={handleChatBotIconClick}
          >
            Retry
          </button>
        </div>
      );
    } else if (loaderName !== undefined && loaderName !== "") {
      loaderElement = (
        <div className="loadertitle">
          <img
            src={images.Magicimage}
            className="botImg"
            id="iris-title"
            alt="Iris title icon"
          />
          <div className="loaderbody">
            <b> {loaderName}</b>
            <br />
            {fakebot.is_getting_ready_for_you}
            <div className="loadermessage">{fakebot.Please_wait_IRIS}</div>
          </div>
        </div>
      );
    } else {
      loaderElement = (
        <div className="loadertitle">
          <img
            src={images.CoffeeLoader}
            className="botImg"
            id="iris-title"
            alt="Iris title icon"
          />
          <div className="loaderbody">
            <b>{fakebot.Brewing_up_some_digital_conversationnmagic}</b>
            <div className="loadermessage">{fakebot.Please_wait_IRIS}</div>
          </div>
        </div>
      );
    }

    return (
      <>
        {renderFullHeader()}
        {renderNotificationsPanel()}
        {isMCAPSChatBotStarted === true ? renderMCAPSChatBot() : null}
        <Suspense fallback={<></>}>
          <FeedbackPanel
            isOpen={isFeedbackPanelOpen}
            onDismiss={() => setIsFeedbackPanelOpen(false)}
            currentUserData={props.currentUserData}
          />
        </Suspense>

        {/* MCAPS Copilot Panel */}
        {canShowMcapsCopilot && (
          <MCAPSCopilotPanelWrapper
            isOpen={isCopilotPanelOpen}
            userEmail={props.user?.email || ''}
            userFullName={props.user?.name || ''}
            onClose={() => {
              userDismissedDefaultCopilotRef.current = true;
              closeMCAPSCopilot({
                initializeIris: !isDefaultMcapsCopilotEnabled
              });
            }}
            onExitTileContext={exitTileContext}
            context={copilotContext}
            isDefaultAgentEnabled={isDefaultMcapsCopilotEnabled}
            apiUrl={process.env.REACT_APP_ENABLE_ADAPTIVE_CARD_RENDERING === 'true' ? 'api/ragquery/askcard' : 'api/ragquery/ask'}
            themeMode={'light'}
            initialPrompt={props.initialCopilotPrompt || initialCopilotPrompt}
            onInitialPromptApplied={() => setInitialCopilotPrompt(undefined)}
          />
        )}
        {/* <AnnouncementBanner  currentUserData={props.currentUserData} /> */}
        {isBotLoader && !props.isPrompt && !props.isFeedbackTab && !(isDefaultMcapsCopilotEnabled && isCopilotPanelOpen) && !suppressIrisLoaderForPendingMcaps ? (
          <div className="fakebot-container">
            <div className="loaderbox" style={{ alignItems: "top" }}>
              <div className="header">
                <img
                  src="https://iris-fd-cpc8d6c9buafasc2.b01.azurefd.net/iris-ux/assets/images/iris-copilot-icon.svg"
                  id="iris-title-icon"
                  alt="Iris title icon"
                />
                <span className="headertitle">{fakebot.Iris_Copilot}</span>
              </div>
              <div>{loaderElement}</div>
            </div>
          </div>
        ) : null}
      </>
    );
  };

  return renderMain();
};

export const V2_AppHeader = withRouter(injectIntl(V2_AppHeaderComponent));

// Generated by Copilot
// updated on: 2025-10-14 | 15 lines added/updated | Auto Generated | Added feedback panel integration to header component with state management and lazy loading support | Time Taken 3 min
// updated on: 2026-03-19 | 14 lines added/updated | [Auto Generated] | Zero-deploy tile routing: replaced hardcoded ECIF/SOS event handling with generic event.detail.appName, added race condition fix with setTimeout, added oldAppName !== newAppName guard to prevent redundant cache invalidation | Time Taken 15 min
// updated on: 2026-03-19 | 1 line updated | [Auto Generated] | Updated comment: appName now sourced from dedicated DB AppName column instead of pipe-parsed IrisAppName | Time Taken 1 min
